import dayjs from "dayjs";

export const addDay = (date, countDay) => {
  return dayjs(date).add(countDay, "day").format("YYYY-MM-DD");
};
